export const REFERRAL_ME_QUERY_KEY = 'referralMe';
export const REFERRAL_CODE_QUERY_KEY = 'referralCode';
export const REFERRAL_SUMMARY_QUERY_KEY = 'referralSummary';
export const REFERRAL_LIST_QUERY_KEY = 'referralList';
export const REFERRAL_ACTIVITY_QUERY_KEY = 'referralActivity';
export const REFERRAL_HISTORY_QUERY_KEY = 'referralHistory';
export const REFERRAL_EARNINGS_QUERY_KEY = 'referralEarnings';

export const referralKeys = {
  me: () => [REFERRAL_ME_QUERY_KEY] as const,
  code: () => [REFERRAL_CODE_QUERY_KEY] as const,
  summary: () => [REFERRAL_SUMMARY_QUERY_KEY] as const,
  referrals: () => [REFERRAL_LIST_QUERY_KEY] as const,
  activity: () => [REFERRAL_ACTIVITY_QUERY_KEY] as const,
  history: () => [REFERRAL_HISTORY_QUERY_KEY] as const,
  earnings: () => [REFERRAL_EARNINGS_QUERY_KEY] as const,
};
